// extracted by mini-css-extract-plugin
module.exports = {"content":"ExpandableRibbon_content__hvRD1"};